import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
// @ts-ignore
import logoImage from '../../image-assets/logo.svg';
import './Login.css';
import { supabase } from '../../lib/supabase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already signed in
  useEffect(() => {
    if (user) {
      navigate('/overview');
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Store email for OTP verification
      localStorage.setItem('userEmail', email);

      // Check if user exists in Profiles table
      const { data } = await supabase
        .from('Profiles')
        .select('id')
        .eq('email', email)
        .single();

      if (!data) {
        // New user: set onboarding flag
        localStorage.setItem('isSignUp', 'true');
      } else {
        // Existing user: clear onboarding flag
        localStorage.removeItem('isSignUp');
      }

      await signIn(email);
      navigate('/verify');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src={logoImage} alt="Texta Logo" className="login-logo-image" />
        </div>
        
        <div className="login-content">
          <h1 className="login-title">Speak a language everyone understands</h1>
          <p className="login-subtitle">Sign in to continue to Texta</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-form-fields">
              <Input
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                error={error}
                sizeVariant="large"
                required
              />
            </div>
            
            <Button 
              type="submit" 
              className="login-button"
              variant="primary"
              size="large"
              disabled={loading}
              isLoading={loading}
            >
              Continue
            </Button>
          </form>
        </div>
        
        <div className="login-footer">
          Don't have an account?{' '}
          <a href="/signup" className="login-link">
            Sign up
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login; 